import React from 'react';
import classNames from 'classnames';

// @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
function Checkbox({
  id,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string | undefined'.
  name = null,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '(...arg... Remove this comment to see the full error message
  onChange = null,
  checked = false,
  disabled = false,
  children,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
  className = null,
  value = '',
  ...otherProps
}) {
  const checkboxClasses = classNames('ws-checkbox', className, {
    'ws-checkbox--disabled': disabled,
  });

  return (
    <div className={checkboxClasses}>
      <label htmlFor={id} className="ws-checkbox__label">
        <input
          className="ws-checkbox__input"
          type="checkbox"
          id={id}
          name={name}
          // @ts-ignore TS(2322): Type 'null' is not assignable to type '((...args: any[]) => any) | undefined'.
          onChange={onChange}
          defaultChecked={checked}
          disabled={disabled}
          value={value}
          {...otherProps}
        />
        <i className="ws-checkbox__checkmark" />
      </label>
      <div className="ws-checkbox__children">{children}</div>
    </div>
  );
}

export default Checkbox;
